<template>
  <div class="productCartDropdown">
    <nuxt-link
      :to="localePath({ name: 'product-slug', params: { slug: product.slug } })"
      class="productCartDropdown__image"
    >
      <new-image-box
        v-if="product.pictureUrl"
        :alt="product.name"
        :src="product.pictureUrl"
        :width="85"
        :height="75"
        image-params="w_85,h_75"
      />
    </nuxt-link>
    <div class="productCartDropdown__name">
      <nuxt-link
        :to="localePath({ name: 'product-slug', params: { slug: product.slug } })"
        class="productCartDropdown__nameContent"
      >
        {{ product.name }}
      </nuxt-link>
    </div>
    <div class="productCartDropdown__count">
      <div class="productCartDropdown__countInner">
        <add-to-basket
          v-model="count"
          :quantity="product.quantity"
          :uom="product.uom"
          small
          disable-show-default-button
          @input="debounceChangeCountInput"
          @change="changeCountInput"
        />
      </div>
    </div>
    <div class="productCartDropdown__value">
      <div class="productCartDropdown__price">
        {{ product.priceObject.currencyPrefix }}
        <b>
          {{
            showNetPrices ? product.priceObject.netFormatted : product.priceObject.grossFormatted
          }}
        </b>
        {{ product.priceObject.currencyPostfix }}
        {{ showNetPrices ? $t('net') : $t('gross') }}
      </div>
      <button class="productCartDropdown__delete" @click="deleteProductFromCart(product)">
        <span class="icon-delete"></span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { debounce } from 'vue-debounce';
import NewImageBox from '@/components/NewImageBox';
import cartMixin from '~/mixins/cart';
import AddToBasket from '~/components/AddToBasket';

export default {
  name: 'ProductCartDropdown',
  components: {
    NewImageBox,
    AddToBasket,
  },
  mixins: [cartMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      count: this.product.quantity,
    };
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
  },
  methods: {
    async changeCountInput(val) {
      if (val < 1) {
        await this.deleteProductFromCart(this.product);
      } else {
        await this.updateProductsAmount(this.product, val, false, false, true).then(() => {
          this.count = val;
        });
      }
    },
    // eslint-disable-next-line space-before-function-paren
    debounceChangeCountInput: debounce(function (val) {
      this.changeCountInput(val);
    }, 1500),
  },
};
</script>

<style lang="scss" scoped>
.productCartDropdown {
  display: flex;
  padding: 1rem 0 1rem 0;
  border-bottom: 1px solid $cAddLight;
  font-size: 1.4rem;
  line-height: 1.6rem;

  b {
    font-weight: 700;
  }

  &:last-child {
    border-bottom: 0;
  }

  &__image {
    flex: 0 0 12%;
    max-width: 12%;
  }

  &__name {
    flex: 0 0 33%;
    max-width: 33%;
    display: flex;
    align-items: center;
  }

  &__count,
  &__value {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__count {
    flex: 0 0 25%;
    max-width: 25%;
    padding: 0 2rem;
  }

  &__value {
    flex: 0 0 30%;
    max-width: 30%;
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 75px;
    padding-right: 15px;
    transition: opacity $tr;

    img {
      max-width: 100%;
      max-height: 80%;
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &__content {
    flex: 1;
  }

  &__nameContent {
    margin-bottom: 1rem;
    display: block;
    transition: color $tr;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    &:hover {
      color: $cSec;
    }
  }

  &__delete {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    line-height: 1;
    width: 4rem;
    height: 4rem;
    margin-left: 0.5rem;
    color: $cAddDark02;
    transition: color $tr, border $tr;

    &:hover {
      color: $cSec;
    }
  }
}
</style>
